import React from "react";
import { CountryDropdown } from "react-country-region-selector";

var CustomCountry = function CustomCountry(props) {
  return React.createElement(CountryDropdown, {
    className: "custom-select",
    value: props.value,
    onChange: props.onChange,
    defaultOptionLabel: props.defaultOptionLabel,
    valueType: props.valueType,
    labelType: props.labelType,
    priorityOptions: props.priorityOptions
  });
};

export default CustomCountry;